// SkeletonSliderComponent.js
import React from "react";
import Skeleton from "react-loading-skeleton";

const SkeletonSliderComponent = () => {
  // const categorySkeletons = Array.from({ length: 5 }, (_, index) => index); // Generate 5 skeleton tabs
  const slideSkeletons = Array.from({ length: 5 }, (_, index) => index); // Generate 5 skeleton slides

  return (
    <>
      {/* Category Tabs Skeleton */}
      {/* <div
        className="nav-container"
        style={{
          overflowX: "auto",
          whiteSpace: "nowrap",
          borderBottom: "2px solid #dee2e6",
        }}
      >
        <ul
          className="nav"
          style={{ display: "flex", flexWrap: "nowrap", padding: 0 }}
        >
          {categorySkeletons.map((_, index) => (
            <li
              key={index}
              className="nav-item"
              style={{ display: "inline-block" }}
            >
              <Skeleton width={100} height={30} />
            </li>
          ))}
        </ul>
      </div> */}

      {/* Slider Skeleton */}
      <div className="card-body position-relative">
        <button
          className="btn btn-dark position-absolute top-50 translate-middle-y"
          style={{ zIndex: 10, left: -15 }}
          disabled
        >
          ❮
        </button>

        {/* Slide Skeletons */}
        <div className="overflow-hidden">
          <div
            className="row flex-nowrap"
            style={{
              transform: "translateX(0%)",
              transition: "0.5s",
            }}
          >
            {slideSkeletons.map((_, index) => (
              <div key={index} className="col-12 col-md-4">
                <div className="card h-100">
                  <Skeleton className="border" height={150} width="100%" />
                  <div className="card-body border-start border-end">
                    <Skeleton className="d-block" width={120} height={20} />
                    <Skeleton width={80} height={15} />
                  </div>
                  <div className="card-footer bg-primary bg-opacity-10">
                    <Skeleton width={50} height={20} />
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>

        <button
          className="btn btn-dark position-absolute top-50 translate-middle-y"
          style={{ zIndex: 10, right: -15 }}
          disabled
        >
          ❯
        </button>
      </div>
    </>
  );
};

export default SkeletonSliderComponent;
